// service.js
import API from "../../services/api.svelte.js"; // Ajustá el path relativo según corresponda

export function get(config = {}) {
    return API.get('v2/sla-config', config);
}

export function save(data, config = {}) {
    console.log(data, "data sla")
    // Pasamos un array vacío [] para el parámetro "files".
    return API.saveSLA(data, config)
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json().catch(() => ({ message: "Error del servidor" }));
                throw errors;
            }
            // Retorna json si lo hay, o un objeto vacío si es un 204 No Content
            return response.json().catch(() => ({}));
        });
}

export default {
    get,
    save
};